import { Box, Tab, Tabs, Typography } from '@mui/material'
import { CalendarTodayOutlined } from '@mui/icons-material'
import { TABS } from './boardShell'

// Next 3 Months and Months 4–18 (FAR-77 §4, FAR-83 §0: the Weekly tab is
// removed). Labels come from the plan's months ("Oct 2026 → Dec 2026"),
// falling back to the horizon names until the months load. Switching tabs
// changes only the horizon in view -- never the plan, its Base Plan or
// Modification.
//
// FAR-88 S3 / FAR-90 S3: labels about 16px; the active tab green and semibold
// with a 3px green underline, inactive tabs muted gray. The release pill (H2)
// sits at the right of the tab row; it is information only.
export default function BoardTabs({ value, onChange, labels = {}, release = null }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
      <Tabs
        value={value}
        onChange={(_, v) => onChange(v)}
        aria-label="Planning horizon"
        sx={{
          flex: 1,
          minHeight: 44,
          '& .MuiTab-root': {
            minHeight: 44, px: 3, textTransform: 'none', fontSize: '1rem', fontWeight: 500,
            letterSpacing: 0, color: 'text.secondary',
          },
          '& .MuiTab-root.Mui-selected': { color: 'primary.main', fontWeight: 600 },
          '& .MuiTabs-indicator': { backgroundColor: 'primary.main', height: 3 },
        }}
      >
        {TABS.map((t) => (
          <Tab key={t.key} value={t.key} label={labels[t.key] || t.label} aria-label={t.label} />
        ))}
      </Tabs>
      {release && (
        <Box
          data-testid="release-pill"
          sx={{
            display: 'inline-flex', alignItems: 'center', gap: 0.75, flexShrink: 0,
            height: 30, px: 1.5, mb: 0.75, borderRadius: 999,
            border: '1px solid', borderColor: 'divider', bgcolor: 'surface.containerLow',
            whiteSpace: 'nowrap',
          }}
        >
          <CalendarTodayOutlined sx={{ fontSize: 15, color: 'text.secondary' }} />
          <Typography component="span" sx={{ fontSize: '0.8125rem', fontWeight: 700, color: 'text.primary' }}>
            {release.through}
          </Typography>
          <Typography component="span" sx={{ fontSize: '0.8125rem', color: 'text.secondary' }}>
            · {release.next}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
